export function uploadDone() {
    const event = new CustomEvent("pos/upload_done");
    document.dispatchEvent(event);
}